(function () {
  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
  const rand = (min, max) => min + Math.random() * (max - min);

  function initAll() {
    document.querySelectorAll('.zodiac-landing').forEach(initSection);
  }

  function initSection(section) {
    if (section.dataset.zInit === '1') return;
    section.dataset.zInit = '1';

    const wheel = section.querySelector('[data-wheel]');
    const nodes = Array.from(section.querySelectorAll('.zodiac-node'));
    const chips = Array.from(section.querySelectorAll('.zodiac-chip')); // mobile slider
    const resetBtns = Array.from(section.querySelectorAll('[data-reset]'));
    const hintDesktop = section.querySelector('.zodiac-wheel__hint-text');
    const hintMobile = section.querySelector('.zodiac-mobile__hint-text');
    const grid = section.querySelector('[data-products-grid]');
    const empty = section.querySelector('[data-empty]');
    const canvas = section.querySelector('.zodiac-bg-canvas');

    const productsWrap =
      section.querySelector('.zodiac-products') ||
      grid?.closest('.zodiac-products') ||
      grid?.parentElement;

    const defaultHint = section.getAttribute('data-default-hint') || '';

    // ---- Wheel placement (desktop)
    const placeNodes = () => {
      if (!wheel || !nodes.length) return;

      const cs = getComputedStyle(wheel);
      const radius = parseFloat(cs.getPropertyValue('--z-wheel-radius')) || 260;

      const rect = wheel.getBoundingClientRect();
      const cx = rect.width / 2;
      const cy = rect.height / 2;

      nodes.forEach((btn) => {
        const angleStr = btn.getAttribute('data-angle') || '0';
        const angleDeg = parseFloat(angleStr);
        const a = (angleDeg - 90) * (Math.PI / 180);

        const x = cx + radius * Math.cos(a);
        const y = cy + radius * Math.sin(a);

        const bw = btn.offsetWidth || 112;
        const bh = btn.offsetHeight || 112;

        btn.style.left = (x - bw / 2) + 'px';
        btn.style.top = (y - bh / 2) + 'px';
      });
    };

    const safePlace = () => {
      placeNodes();
      setTimeout(placeNodes, 120);
      setTimeout(placeNodes, 700);
    };

    safePlace();
    window.addEventListener('resize', safePlace);

    // ---- Filter helpers
    let activeSign = null;

    function hideCard(card) {
      if (card.hasAttribute('hidden')) return;
      card.classList.add('is-hidden');
      setTimeout(() => card.setAttribute('hidden', ''), 210);
    }

    function showCard(card) {
      if (card.hasAttribute('hidden')) {
        card.removeAttribute('hidden');
        requestAnimationFrame(() => card.classList.remove('is-hidden'));
      } else {
        card.classList.remove('is-hidden');
      }
    }

    function applyFilter(sign) {
      if (!grid) return;

      const cards = Array.from(grid.querySelectorAll('[data-product]'));
      let visibleCount = 0;

      cards.forEach((card) => {
        const cardSign = (card.getAttribute('data-sign') || '').toLowerCase().trim();
        if (!sign) {
          showCard(card);
          visibleCount++;
          return;
        }
        if (cardSign === sign) {
          showCard(card);
          visibleCount++;
        } else {
          hideCard(card);
        }
      });

      if (empty) empty.hidden = visibleCount !== 0;
    }

    function setHint(text) {
      if (hintDesktop) hintDesktop.textContent = text;
      if (hintMobile) hintMobile.textContent = text;
    }

    function scrollToProducts() {
      if (!productsWrap) return;

      const header = document.querySelector('header, .header-wrapper, .shopify-section-header');
      const headerH = header ? header.getBoundingClientRect().height : 0;
      const top = window.scrollY + productsWrap.getBoundingClientRect().top - Math.min(headerH + 18, 120);

      window.scrollTo({ top, behavior: 'smooth' });

      productsWrap.classList.remove('is-pulse');
      void productsWrap.offsetWidth;
      productsWrap.classList.add('is-pulse');
      setTimeout(() => productsWrap.classList.remove('is-pulse'), 950);
    }

    function activateSign(sign, labelText, sourceEl) {
      activeSign = sign || null;

      // desktop buttons
      nodes.forEach((b) => {
        const s = (b.getAttribute('data-sign') || '').toLowerCase().trim();
        const on = !!activeSign && s === activeSign;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      // mobile chips
      chips.forEach((c) => {
        const s = (c.getAttribute('data-sign') || '').toLowerCase().trim();
        const on = !!activeSign && s === activeSign;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      applyFilter(activeSign);
      setHint(labelText || defaultHint);

      // mobilde seçilen chip ekrana gelsin
      if (sourceEl && sourceEl.classList.contains('zodiac-chip')) {
        sourceEl.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }

      scrollToProducts();
    }

    // ---- Desktop wheel click
    nodes.forEach((btn) => {
      btn.addEventListener('click', () => {
        const sign = (btn.getAttribute('data-sign') || '').toLowerCase().trim();
        const n = btn.querySelector('.zodiac-node__name')?.textContent?.trim() || '';
        const d = btn.querySelector('.zodiac-node__dates')?.textContent?.trim() || '';
        const label = d ? `${n} • ${d}` : n;
        activateSign(sign, label, btn);
      });
    });

    // ---- Mobile slider click
    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        const sign = (chip.getAttribute('data-sign') || '').toLowerCase().trim();
        const n = chip.querySelector('.zodiac-chip__name')?.textContent?.trim() || '';
        const d = chip.querySelector('.zodiac-chip__dates')?.textContent?.trim() || '';
        const label = d ? `${n} • ${d}` : n;
        activateSign(sign, label, chip);
      });
    });

    // ---- Reset (works for both)
    resetBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        activeSign = null;
        nodes.forEach((b) => { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
        chips.forEach((c) => { c.classList.remove('is-active'); c.setAttribute('aria-selected', 'false'); });
        applyFilter(null);
        setHint(defaultHint);
        scrollToProducts();
      });
    });

    // ---- Background mode (keep your existing system)
    const bgMode = (section.getAttribute('data-bg-mode') || 'canvas').toLowerCase();
    if (bgMode === 'canvas' && canvas) initBackground(section, canvas);

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) safePlace(); });
    }, { threshold: 0.15 });
    io.observe(section);
  }

  /* ===== Background (same optimized cached-nebula approach) ===== */
  function initBackground(section, canvas) {
    const ctx = canvas.getContext('2d', { alpha: true });
    if (!ctx) return;

    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile = matchMedia('(max-width: 768px)').matches;

    const intensity = (section.getAttribute('data-bg-intensity') || 'balanced').toLowerCase();
    const pauseOffscreen = section.getAttribute('data-bg-pause-offscreen') === 'true';

    const density = (section.getAttribute('data-stars-density') || 'auto').toLowerCase();
    const shootingRate = (section.getAttribute('data-shooting-rate') || 'auto').toLowerCase();
    const grainLevel = (section.getAttribute('data-grain-level') || 'auto').toLowerCase();

    const dprCapSetting = (section.getAttribute('data-bg-dpr-cap') || 'auto').toLowerCase();
    const dprCap =
      dprCapSetting === '1.0' ? 1.0 :
      dprCapSetting === '1.25' ? 1.25 :
      dprCapSetting === '1.5' ? 1.5 :
      (isMobile ? 1.10 : 1.6);

    const basePreset = {
      low:      { starCount: isMobile ? 95  : 240, twinkle: 0.012, drift: 0.030, shootEvery: isMobile ? 2400 : 1600, noiseDots: isMobile ? 90  : 360 },
      balanced: { starCount: isMobile ? 130 : 360, twinkle: 0.016, drift: 0.045, shootEvery: isMobile ? 1900 : 1200, noiseDots: isMobile ? 110 : 520 },
      rich:     { starCount: isMobile ? 165 : 520, twinkle: 0.020, drift: 0.055, shootEvery: isMobile ? 1500 : 900,  noiseDots: isMobile ? 140 : 700 }
    }[intensity] || { starCount: isMobile ? 130 : 360, twinkle: 0.016, drift: 0.045, shootEvery: isMobile ? 1900 : 1200, noiseDots: isMobile ? 110 : 520 };

    const densityMul =
      density === 'low' ? 0.72 :
      density === 'high' ? 1.18 :
      density === 'medium' ? 1.0 : 1.0;

    const shootEvery =
      shootingRate === 'off' ? 1e15 :
      shootingRate === 'rare' ? basePreset.shootEvery * 1.6 :
      shootingRate === 'frequent' ? basePreset.shootEvery * 0.72 :
      shootingRate === 'normal' ? basePreset.shootEvery : basePreset.shootEvery;

    const noiseMul =
      grainLevel === 'off' ? 0 :
      grainLevel === 'low' ? 0.55 :
      grainLevel === 'medium' ? 1.0 : 1.0;

    const preset = {
      starCount: Math.max(40, Math.floor(basePreset.starCount * densityMul)),
      twinkle: basePreset.twinkle,
      drift: basePreset.drift,
      shootEvery,
      noiseDots: Math.floor(basePreset.noiseDots * noiseMul)
    };

    let w = 0, h = 0, dpr = 1;
    let stars = [];
    let shooters = [];
    let raf = 0;
    let running = true;

    const cache = document.createElement('canvas');
    const cctx = cache.getContext('2d');

    let nextShootAt = performance.now() + preset.shootEvery;
    let lastT = performance.now();
    let cacheTick = 0;

    function readVar(name, fallback) {
      const v = getComputedStyle(section).getPropertyValue(name).trim();
      return v || fallback;
    }
    const c1 = readVar('--z-c1', '#2A8CFF');
    const c2 = readVar('--z-c2', '#FF4FB8');
    const c3 = readVar('--z-c3', '#9B5BFF');
    const c4 = readVar('--z-c4', '#30E3CA');

    function resize() {
      const rect = section.getBoundingClientRect();
      dpr = Math.max(1, Math.min(dprCap, window.devicePixelRatio || 1));

      w = Math.max(320, Math.floor(rect.width));
      h = Math.max(620, Math.floor(rect.height));

      canvas.width = Math.floor(w * dpr);
      canvas.height = Math.floor(h * dpr);
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      cache.width = Math.floor(w * dpr);
      cache.height = Math.floor(h * dpr);
      cctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      buildStars();
      redrawCache();
      drawOnce();
    }

    function buildStars() {
      stars = [];
      for (let i = 0; i < preset.starCount; i++) {
        const z = Math.random();
        const roll = Math.random();
        const tone =
          roll > 0.90 ? 'gold' :
          roll > 0.74 ? 'pink' :
          roll > 0.60 ? 'blue' :
          roll > 0.46 ? 'violet' :
          roll > 0.32 ? 'cyan' : 'white';

        stars.push({
          x: Math.random() * w,
          y: Math.random() * h,
          z,
          r: rand(0.85, 2.0) + z * 1.4,
          a: rand(0.28, 0.95) * (0.55 + z * 0.55),
          tw: rand(0.0015, preset.twinkle),
          ph: rand(0, Math.PI * 2),
          tone
        });
      }
    }

    function redrawCache() {
      cctx.clearRect(0, 0, w, h);

      const g1 = cctx.createRadialGradient(w * 0.22, h * 0.24, 0, w * 0.22, h * 0.24, Math.max(w, h) * 0.95);
      g1.addColorStop(0, hexToRgba(c1, 0.24));
      g1.addColorStop(0.60, hexToRgba(c1, 0.08));
      g1.addColorStop(1, 'rgba(0,0,0,0)');

      const g2 = cctx.createRadialGradient(w * 0.78, h * 0.26, 0, w * 0.78, h * 0.26, Math.max(w, h) * 0.95);
      g2.addColorStop(0, hexToRgba(c2, 0.20));
      g2.addColorStop(0.62, hexToRgba(c2, 0.07));
      g2.addColorStop(1, 'rgba(0,0,0,0)');

      const g3 = cctx.createRadialGradient(w * 0.55, h * 0.54, 0, w * 0.55, h * 0.54, Math.max(w, h) * 0.90);
      g3.addColorStop(0, hexToRgba(c3, 0.18));
      g3.addColorStop(0.65, hexToRgba(c3, 0.06));
      g3.addColorStop(1, 'rgba(0,0,0,0)');

      const g4 = cctx.createRadialGradient(w * 0.50, h * 0.86, 0, w * 0.50, h * 0.86, Math.max(w, h) * 0.95);
      g4.addColorStop(0, hexToRgba(c4, 0.12));
      g4.addColorStop(0.70, hexToRgba(c4, 0.05));
      g4.addColorStop(1, 'rgba(0,0,0,0)');

      cctx.fillStyle = g1; cctx.fillRect(0, 0, w, h);
      cctx.fillStyle = g2; cctx.fillRect(0, 0, w, h);
      cctx.fillStyle = g3; cctx.fillRect(0, 0, w, h);
      cctx.fillStyle = g4; cctx.fillRect(0, 0, w, h);

      if (preset.noiseDots > 0) {
        const noiseAlpha = intensity === 'rich' ? 0.028 : intensity === 'low' ? 0.014 : 0.022;
        cctx.globalAlpha = noiseAlpha;
        for (let i = 0; i < preset.noiseDots; i++) {
          cctx.fillStyle = Math.random() > 0.5 ? 'rgba(255,255,255,1)' : 'rgba(0,0,0,1)';
          cctx.fillRect(Math.random() * w, Math.random() * h, Math.random() * 1.2, Math.random() * 1.2);
        }
        cctx.globalAlpha = 1;
      }
    }

    function drawNebula() {
      ctx.clearRect(0, 0, w, h);
      ctx.drawImage(cache, 0, 0, w, h);
    }

    function starCoreRGB(tone) {
      if (tone === 'gold')   return '242,215,170';
      if (tone === 'pink')   return '255,175,230';
      if (tone === 'blue')   return '185,230,255';
      if (tone === 'violet') return '210,180,255';
      if (tone === 'cyan')   return '180,245,255';
      return '235,245,255';
    }

    function driftStars(dt) {
      const base = preset.drift;
      for (const s of stars) {
        const speed = base * (0.35 + s.z * 1.05);
        s.x += speed * dt * 14;
        s.y += speed * dt * 8;
        if (s.x > w + 10) s.x = -10;
        if (s.y > h + 10) s.y = -10;
      }
    }

    function drawStars(t) {
      ctx.save();
      ctx.globalCompositeOperation = 'lighter';

      for (const s of stars) {
        const pulse = 0.60 + (Math.sin(t * s.tw + s.ph) + 1) * 0.33;
        const alpha = clamp(s.a * (0.56 + pulse * 0.72), 0, 1);

        const r = s.r;
        const glowR = r * (3.8 + pulse * 1.9);
        const core = starCoreRGB(s.tone);

        const g = ctx.createRadialGradient(s.x, s.y, 0, s.x, s.y, glowR);
        g.addColorStop(0, `rgba(${core}, ${alpha})`);
        g.addColorStop(0.22, `rgba(${core}, ${alpha * 0.52})`);
        g.addColorStop(0.60, `rgba(${core}, ${alpha * 0.16})`);
        g.addColorStop(1, `rgba(${core}, 0)`);

        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(s.x, s.y, glowR, 0, Math.PI * 2);
        ctx.fill();

        ctx.globalAlpha = clamp(alpha * 0.92, 0, 1);
        ctx.fillStyle = `rgba(${core}, 1)`;
        ctx.beginPath();
        ctx.arc(s.x, s.y, Math.max(0.75, r * (0.92 + pulse * 0.18)), 0, Math.PI * 2);
        ctx.fill();
        ctx.globalAlpha = 1;
      }

      ctx.restore();
    }

    function spawnShooter() {
      const edge = Math.floor(rand(0, 4));
      let x, y;
      if (edge === 0) { x = rand(0, w); y = rand(-50, 40); }
      if (edge === 1) { x = rand(-60, 40); y = rand(0, h); }
      if (edge === 2) { x = rand(w - 40, w + 60); y = rand(0, h); }
      if (edge === 3) { x = rand(0, w); y = rand(h - 40, h + 60); }

      const angle = rand(18, 62) * (Math.PI / 180);
      const speed = isMobile ? rand(7.0, 11.0) : rand(10.0, 17.0);
      const len = isMobile ? rand(90, 160) : rand(130, 230);

      shooters.push({ x, y, vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed, life: 0, maxLife: rand(isMobile ? 18 : 22, isMobile ? 30 : 40), len });
    }

    function drawShooters() {
      ctx.save();
      ctx.globalCompositeOperation = 'lighter';

      for (let i = shooters.length - 1; i >= 0; i--) {
        const sh = shooters[i];
        sh.x += sh.vx;
        sh.y += sh.vy;
        sh.life += 1;

        const p = sh.life / sh.maxLife;
        const a = clamp(1 - p, 0, 1);

        const x2 = sh.x - sh.vx * (sh.len / 12);
        const y2 = sh.y - sh.vy * (sh.len / 12);

        const grad = ctx.createLinearGradient(sh.x, sh.y, x2, y2);
        grad.addColorStop(0, `rgba(255,255,255,${0.80 * a})`);
        grad.addColorStop(0.25, `rgba(255,175,230,${0.30 * a})`);
        grad.addColorStop(0.55, `rgba(185,230,255,${0.20 * a})`);
        grad.addColorStop(1, `rgba(255,255,255,0)`);

        ctx.strokeStyle = grad;
        ctx.lineWidth = isMobile ? 1.4 : 2;
        ctx.beginPath();
        ctx.moveTo(sh.x, sh.y);
        ctx.lineTo(x2, y2);
        ctx.stroke();

        if (sh.life >= sh.maxLife || sh.x < -400 || sh.y < -400 || sh.x > w + 400 || sh.y > h + 400) {
          shooters.splice(i, 1);
        }
      }

      ctx.restore();
    }

    function drawOnce() { drawNebula(); drawStars(0); }

    function frame(tms) {
      if (!running) return;

      const t = tms * 0.001;
      const dt = clamp((tms - lastT) / 1000, 0, 0.05);
      lastT = tms;

      cacheTick++;
      if (cacheTick % (isMobile ? 36 : 22) === 0) redrawCache();

      drawNebula();
      driftStars(dt);
      drawStars(t);

      if (!reducedMotion && tms >= nextShootAt) {
        const count = isMobile ? 1 : (Math.random() > 0.78 ? 2 : 1);
        for (let i = 0; i < count; i++) spawnShooter();
        nextShootAt = tms + preset.shootEvery + rand(-450, 650);
      }
      if (!reducedMotion) drawShooters();

      raf = requestAnimationFrame(frame);
    }

    function start() {
      if (running) return;
      running = true;
      lastT = performance.now();
      raf = requestAnimationFrame(frame);
    }

    function stop() {
      running = false;
      if (raf) cancelAnimationFrame(raf);
      raf = 0;
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    if (pauseOffscreen) {
      const io = new IntersectionObserver((entries) => {
        const on = entries.some(e => e.isIntersecting);
        if (on) start();
        else stop();
      }, { threshold: 0.08 });
      io.observe(section);
    }

    const ro = new ResizeObserver(() => resize());
    ro.observe(section);

    resize();

    if (reducedMotion) { stop(); drawOnce(); return; }
    raf = requestAnimationFrame(frame);
  }

  function hexToRgba(input, a) {
    if (!input) return `rgba(255,255,255,${a})`;
    const s = input.trim();
    if (s.startsWith('rgb')) {
      return s.replace(/rgba?\(([^)]+)\)/, (m, inner) => {
        const parts = inner.split(',').map(p => p.trim());
        const r = parts[0] || '255';
        const g = parts[1] || '255';
        const b = parts[2] || '255';
        return `rgba(${r}, ${g}, ${b}, ${a})`;
      });
    }
    const hex = s.replace('#', '');
    const full = hex.length === 3 ? hex.split('').map(ch => ch + ch).join('') : hex;
    const r = parseInt(full.slice(0,2), 16);
    const g = parseInt(full.slice(2,4), 16);
    const b = parseInt(full.slice(4,6), 16);
    return `rgba(${r},${g},${b},${a})`;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
